export default "__VITE_ASSET__C9iiU7Ia__"